module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@3x-94f1bf332adc15b69973a6b69ca19357.png";